<template>
	<div>
		<div v-if="action === 'create'">
			<ul uk-tab>
				<li class="uk-active"><a href="#user-data">{{ $t('user.data') }}</a></li>
				<li><a href="#additional-settings">{{ $t('additional.settings') }}</a></li>
			</ul>
			<ul class="uk-switcher uk-margin">
				<li id="user-data">
					<div class="modal_item">
						<label for="individual-person_login">{{ $t('user.login') + ' (email)' }}</label>
						<br>
						<input id="individual-person_login" class="textInput attribute-editor" type="text"
							   v-model="login" @focusout="checkEmail">
						<button class="button_reset fa fa-times" @click="resetLogin"></button>
					</div>
					<div class="modal_item">
						<label for="individual-person_firstName">{{ $t('first.name') }}</label>
						<br>
						<input id="individual-person_firstName" class="textInput attribute-editor" type="text"
							   v-model="firstName">
						<button class="button_reset fa fa-times" @click="firstName = ''"></button>
					</div>
					<div class="modal_item">
						<label for="individual-person_lastName">{{ $t('last.name') }}</label>
						<br>
						<input id="individual-person_lastName" class="textInput attribute-editor" type="text"
							   v-model="lastName">
						<button class="button_reset fa fa-times" @click="lastName = ''"></button>
					</div>
					<div class="modal_item">
						<label for="individual-person_passwordHash">{{ $t('password') }}</label>
						<br>
						<input id="individual-person_passwordHash" class="textInput attribute-editor" type="password"
							   v-model="passwordHash">
						<button class="button_reset fa fa-times" @click="passwordHash = ''"></button>
					</div>
					<div class="modal_item">
						<label for="individual-person_confirmation-password">{{ $t('confirmation.password') }}</label>
						<br>
						<input id="individual-person_confirmation-password" class="textInput attribute-editor" type="password"
							   v-model="passwordConfirm">
						<button class="button_reset fa fa-times" @click="passwordConfirm = ''"></button>
					</div>
					<div class="modal_item checkbox_item">
						<div class="checkbox-block">
							<input type="checkbox" id="individual-person_temporaryPassword"
								   class="checkbox attribute-editor" v-model="temporaryPassword">
							<label for="individual-person_temporaryPassword">{{ $t('temporary.password') }}</label>
						</div>
					</div>
					<div class="modal_item">
						<label for="individual-person_role">{{ $t('user.role') }}</label>
						<br>
						<select id="individual-person_role" class="select attribute-editor" v-model="roleId">
							<option v-for="role in roles" :value="role.id" :key="role.id">{{ role.name }}</option>
						</select>
					</div>
					<div class="modal_item">
						<label for="individual-person_group">{{ $t('user.group') }}</label>
						<br>
						<select id="individual-person_group" class="select attribute-editor" v-model="groupId">
							<option v-for="group in groups" :value="group.id" :key="group.id">{{ group.name }}</option>
						</select>
					</div>
					<div class="modal_item">
						<label for="individual-person_country">{{ $t('countries') }}</label>
						<br>
						<select id="individual-person_country" class="select attribute-editor" v-model="country">
							<option v-for="(country, key) in countries" :value="key" :key="key"> {{
									$t(country)
								}}
							</option>
						</select>
					</div>
				</li>
				<li id="additional-settings">
					<div class="modal_item">
						<label for="individual-person_description">{{ $t('description') }}</label>
						<br>
						<textarea id="individual-person_description" class="textarea attribute-editor"
								  v-model="description"></textarea>
						<button class="button_reset single-area-reset fa fa-times" @click="description = ''"></button>
					</div>
					<div class="modal_item">
						<label for="individual-person_decimalSeparator">{{ $t('decimal.separator') }}</label>
						<br> <select id="individual-person_decimalSeparator" class="select attribute-editor"
									 v-model="decimalSeparator">
						<option value=".">.</option>
						<option value=",">,</option>
						<option value="\">\</option>
						<option value=" ">{{ $t('space') }}</option>
						<option value="$">$</option>
					</select>
					</div>
					<div class="modal_item">
						<label for="individual-person_digitGroupingPattern">{{ $t('digit.grouping.pattern') }}</label>
						<br>
						<select id="individual-person_digitGroupingPattern" class="select attribute-editor"
								v-model="digitGroupingPattern">
							<option value="0">123456789</option>
							<option value="#,##0">123,456,789</option>
						</select>
					</div>
					<div class="modal_item">
						<label for="individual-person_digitGroupingSeparator">{{
								$t('digit.grouping.separator')
							}}</label>
						<br>
						<select id="individual-person_digitGroupingSeparator" class="select attribute-editor"
								v-model="digitGroupingSeparator">
							<option value=".">.</option>
							<option value=",">,</option>
							<option value="\">\</option>
							<option value=" ">{{ $t('space') }}</option>
							<option value="$">$</option>
						</select>
					</div>
					<div class="modal_item">
						<label for="individual-person_dateFormat">{{ $t('date.format') }}</label>
						<br>
						<select id="individual-person_dateFormat" class="select attribute-editor" v-model="dateFormat">
							<option value="yyyy-MM-dd">yyyy-MM-dd</option>
							<option value="yyyy/MM/dd">yyyy/MM/dd</option>
							<option value="dd-MM-yyyy">dd-MM-yyyy</option>
							<option value="dd/MM/yyyy">dd/MM/yyyy</option>
						</select>
					</div>
				</li>
			</ul>
		</div>
		<div v-if="action === 'edit'">
			<ul uk-tab>
				<li class="uk-active"><a href="#user-edit">{{ $t('user.data') }}</a></li>
			</ul>
			<ul class="uk-switcher uk-margin">
				<li id="user-edit">
					<div class="modal_item">
						<label for="individual-person_login">{{ $t('user.role') }}</label>
						<br>
						<select class="select attribute-editor" v-model="roleId">
							<option v-for="role in roles" :value="role.id" :key="role.id">{{ role.name }}</option>
						</select>
					</div>
					<div class="modal_item">
						<label for="individual-person_login">{{ $t('user.group') }}</label>
						<br>
						<select class="select attribute-editor" v-model="groupId">
							<option v-for="group in groups" :value="group.id" :key="group.id">{{ group.name }}</option>
						</select>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { emailValidation, getLocalizedMessage, showMessageAlert } from '@/core/shared'
import http from 'utils/http'

export default {
	name: 'UserCreateModal',
	data () {
		return {
			apiKey: '',
			dateFormat: 'yyyy-MM-dd',
			decimalSeparator: '.',
			description: '',
			digitGroupingPattern: '0',
			digitGroupingSeparator: ' ',
			firstName: '',
			lastName: '',
			login: '',
			loginPrev: '',
			temporaryPassword: false,
			country: 'EE',
			passwordHash: '',
			passwordConfirm: '',

			individualPersons: [],
			groups: [],
			roles: [],
			action: '',

			roleId: '',
			groupId: '',

			hasPerson: false,
			hasCompanyUser: false,

			user: {},
			person: {}
		}
	},
	computed: {
		countries: function () {
			return this.$store.getters.getCountries
		},
		confirmButton: function () {
			return this.action === 'create' && !this.hasPerson ? this.$t('create') : this.$t('save')
		}
	},
	async mounted () {
		let vm = this
		let manager = window.manager

		vm.individualPersons = manager.individualPersons
		vm.groups = manager.groups
		vm.action = manager.action
		vm.getRoles(manager.companyId)

		if (vm.action === 'edit') {
			vm.roleId = vm.individualPersons.roleId
			vm.groupId = vm.individualPersons.groupId || null
		}

		await Swal.queue([{
			...vm.getModalSettings(),
			showLoaderOnConfirm: true,
			preConfirm: () => {
				let companyId = manager.companyId

				if (vm.hasPerson && !vm.hasCompanyUser) {
					if (vm.validationJoinInputs()) {
						vm.action = 'edit'

						showMessageAlert(vm.$t('user.is.already.registered'), 'success')
						showMessageAlert(vm.$t('username.and.password.not.changed'), 'success')
						showMessageAlert(vm.$t('user.added.to.organization'), 'success')

						return {
							companyId: companyId,
							roleId: vm.roleId,
							groupId: vm.groupId,
							individualPersonId: vm.person.id
						}
					} else {
						return false
					}
				} else if (vm.hasCompanyUser) {
					if (vm.validationJoinInputs()) {
						vm.action = 'edit'

						return {
							id: vm.user.id,
							companyId: companyId,
							roleId: vm.roleId,
							groupId: vm.groupId,
							individualPersonId: vm.user.individualPersonId
						}
					} else {
						return  false
					}
				} else {
					if (vm.action === 'create') {
						if (vm.validationAllInputs()) {

							let individualPersonData = {
								dateFormat: vm.dateFormat,
								decimalSeparator: vm.decimalSeparator,
								description: vm.description,
								digitGroupingPattern: vm.digitGroupingPattern,
								digitGroupingSeparator: vm.digitGroupingSeparator,
								firstName: vm.firstName,
								lastName: vm.lastName,
								login: vm.login,
								temporaryPassword: vm.temporaryPassword,
								country: vm.country,
								passwordHash: vm.passwordHash
							}

							showMessageAlert(vm.$t('create.new.user'), 'success')
							showMessageAlert(vm.$t('user.added.to.organization'), 'success')

							return {
								individualPerson: individualPersonData,
								roleId: vm.roleId,
								groupId: vm.groupId,
							}
						} else {
							return false
						}
					}
				}

				if (vm.action === 'edit') {
					return {
						companyId: companyId,
						roleId: vm.roleId,
						groupId: vm.groupId,
						individualPersonId: manager.user.individualPersonId,
						id: manager.user.id,
						tagIds: []
					}
				}
			},
			onClose: function () {
				vm.$emit('close-modal')
			}
		}]).then(result => {
			if (result.value) {
				if (vm.action === 'edit') {
					manager.saveUser(vm.action, result.value[0])
				}
				if (vm.action === 'create') {
					manager.saveIndividualPerson(result.value[0])
				}
			}
		})
	},
	methods: {
		checkEmail: function () {
			let vm = this
			let companyId = manager.companyId
			let confirmButton = Swal.getConfirmButton()
			let login = vm.login.trim()

			if (emailValidation(login)) {
				if (login !== vm.loginPrev) {
					if (!vm.login) {
						return
					}

					http.post(`/company/${companyId}/person-user`, {}, {
						params: {
							companyId: companyId,
							login: login
						}
					}).then(function ({ data }) {
						vm.hasPerson = !!data.person
						vm.person = data.person || {}

						vm.hasCompanyUser = !!data.user
						vm.user = data.user || {}

						Swal.resetValidationMessage()

						vm.loginPrev = login
					}).then(function () {
						if (vm.hasCompanyUser) {
							vm.roleId = vm.user.roleId
							vm.groupId = vm.user.groupId
							vm.hiddenInputs(true)
							confirmButton.innerText = vm.$t('edit')
							showMessageAlert(vm.$t('user.has.already.been.added'), 'warning')
						} else if (vm.hasPerson && !vm.hasCompanyUser) {
							vm.hiddenInputs(true)
							confirmButton.innerText = vm.$t('join')
							showMessageAlert(vm.$t('user.is.already.registered'), 'primary')

							vm.roleId = ""
							vm.groupId = ""
						} else {
							vm.resetFields()
						}
					})
				}
			} else {
				Swal.showValidationMessage(getLocalizedMessage('incorrect.email'))
			}
		},
		hiddenInputs: function (visible) {
			let toggleInputs = ['firstName', 'lastName', 'passwordHash', 'confirmation-password', 'temporaryPassword', 'country']
			document.getElementById('additional-settings').hidden = visible
			document.querySelector('a[href="#additional-settings"]').closest('li').hidden = visible
			toggleInputs.forEach(function (el) {
				document.getElementById('individual-person_' + el).closest('.modal_item').hidden = visible
			})
		},
		resetFields: function () {
			let confirmButton = Swal.getConfirmButton()
			this.roleId = ""
			this.groupId = ""
			this.hiddenInputs(false)
			confirmButton.innerText = this.$t('create')
			Swal.resetValidationMessage()
		},
		resetLogin: function () {
			this.login = ""
			this.loginPrev = ""
			this.resetFields()
		},
		getRoles: function (companyId) {
			http.post('/company/roles', {}, {
				params: {
					id: companyId
				}
			}).then(roles => {
				let currentRole = this.$store.getters.getRole.name //TODO ограничение списка ролей по имени. для ролей отличных от system
				let isSystem = currentRole.toLowerCase().indexOf('system') !== -1

				if (!isSystem) {
					this.roles = roles.data.filter(role => role.name.toLowerCase().indexOf('system') === -1)
				} else {
					this.roles = roles.data
				}
			})
		},
		getModalSettings: function () {
			return {
				title: this.$t('user'),
				html: this.$el,
				confirmButtonText: this.confirmButton,
				showCancelButton: true,
				cancelButtonText: this.$t('cancel'),
				buttonsStyling: false,
				allowOutsideClick: false,
				allowEnterKey: true,
				showClass: {
					popup: ''
				},
				hideClass: {
					popup: ''
				},
				customClass: {
					content: 'form',
					confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
					cancelButton: 'uk-button uk-button-default uk-button-small',
				}
			}
		},
		validationAllInputs: function () {
			if (!this.login) {
				Swal.showValidationMessage(getLocalizedMessage('login.is.empty'))
				return false
			} else if (!emailValidation(this.login)) {
				Swal.showValidationMessage(getLocalizedMessage('incorrect.email'))
				return false
			} else if (!this.firstName) {
				Swal.showValidationMessage(getLocalizedMessage('first.name.is.empty'))
				return false
			} else if (!this.lastName) {
				Swal.showValidationMessage(getLocalizedMessage('last.name.is.empty'))
				return false
			} else if (!this.passwordHash) {
				Swal.showValidationMessage(getLocalizedMessage('password.is.empty'))
				return false
			} else if (!this.roleId) {
				Swal.showValidationMessage(getLocalizedMessage('select.role'))
				return false
			} else if (this.passwordHash !== this.passwordConfirm) {
				Swal.showValidationMessage(getLocalizedMessage('passwords.dont.match'))
				return false
			} else if (this.action === 'create' && this.passwordHash.length < 8) {
				Swal.showValidationMessage(getLocalizedMessage('password.must.be.at.least.8.characters'))
				return false
			} else if ((this.action === 'edit') && (!_.isEmpty(this.passwordHash) && this.passwordHash.length < 8)) {
				Swal.showValidationMessage(getLocalizedMessage('password.must.be.at.least.8.characters'))
				return false
			} else {
				return true
			}
		},
		validationJoinInputs: function () {
			if (!this.roleId) {
				Swal.showValidationMessage(getLocalizedMessage('select.role'))
				return false
			} else {
				return true
			}
		}
	}
}
</script>

<style scoped>
.checkbox-block {
	margin: 0;
	display: flex;
	align-items: center;
}

.checkbox-block label {
	margin: 0;
}

.checkbox-block input {
	margin: 0 5px 0 0;
}
</style>
